export default __webpack_public_path__ + "static/media/no-results.899b4528.png";